import { ABILITY_BY_HOTKEY, type AbilityMessage } from "@mucki/shared";
import { type TargetCandidate, selectTarget } from "../systems/targeting.js";

/**
 * Turns a number-key press into the message the server expects: the ability id
 * plus the client's chosen target (R32). Abilities that need no target skip
 * selection entirely.
 */
export function resolveAbilityPress(
  hotkey: string,
  origin: { x: number; z: number; rotationY: number },
  candidates: Iterable<TargetCandidate>,
): AbilityMessage | undefined {
  const ability = ABILITY_BY_HOTKEY[hotkey];
  if (!ability) return undefined;

  if (!ability.requiresTarget) return { abilityId: ability.id };

  const targetId = selectTarget(origin, candidates, ability);
  if (!targetId) return undefined;
  return { abilityId: ability.id, targetId };
}
